module.exports = __webpack_public_path__ + "img/ai3.d652d3e8.png";